import { io } from "socket.io-client";
import { getSocketUrl } from "~/libraries/utility";

export default defineNuxtPlugin({
    setup() {
        const socket = io(getSocketUrl(), {
            autoConnect: false,
            transports: ["websocket"],
            reconnection: true, // Enable automatic reconnection
            reconnectionAttempts: Infinity, // Retry indefinitely
            reconnectionDelay: 1000, // Retry every 1 second
            timeout: 5000, // Disconnect if no response within 5 seconds
        });

        return {
            provide: {
                io: socket,
            },
        };
    },
});
